<template>
  <Modal size="small">
    <div class="modal-header" @modalClose="onClose">
      <h4>แก้ไขสถานะการเผยแพร่</h4>
      <button
        type="button"
        @click.stop="onClose"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="modal-body">
        <div class="status-section">
          <label>สถานะ</label>
          <select class="form-control" v-model="statusData.status">
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="scheduled">Scheduled</option>
          </select>
        </div>
        <div class="status-datepublish" v-if="canManageDatePublish()">
          <div class="status-startpublish" v-if="statusData.status === 'scheduled'">
            <label>เริ่มต้นเผยแพร่</label>
            <div class="datetime-container">
              <DateTimePicker
                v-model="statusData.startPublish"
                placeholder="กรุณาเลือกวันที่" />
            </div>
          </div>
          <div class="status-endpublish">
            <div class="checkbox-container">
              <input type="checkbox" class="mr-2" v-model="setEndPublish"/>
              <span>กำหนดวันสิ้นสุดการเผยแพร่</span>
            </div>
            <div class="datetime-container" v-if="setEndPublish">
              <DateTimePicker
                v-model="statusData.endPublish"
                placeholder="กรุณาเลือกวันที่" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="submit">ปิด</button>
      </div>
    </form>
  </Modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

export default {
  props: {
    status: { type: String, default: 'draft' },
    startPublish: { type: [String, Date], default: null },
    endPublish: { type: [String, Date], default: null },
    onClose: { type: Function, default: () => {} },
    onChange: { type: Function, default: () => {} },
  },
  components: {
    Modal,
    DateTimePicker,
  },
  data() {
    return {
      setEndPublish: false,
      statusData: null,
    };
  },
  created() {
    this.statusData = this.mapStatusData();
    this.setEndPublish = this.endPublish || false;
  },
  methods: {
    canManageDatePublish() {
      return this.statusData.status === 'published' || this.statusData.status === 'scheduled';
    },
    mapStatusData() {
      return {
        status: _.cloneDeep(this.status),
        startPublish: _.cloneDeep(this.startPublish),
        endPublish: _.cloneDeep(this.endPublish),
      };
    },
    onSubmit() {
      const date = new Date();
      if (!this.setEndPublish) {
        this.statusData.endPublish = null;
      }
      if (this.statusData.status === 'draft') {
        this.statusData.startPublish = null;
        this.statusData.endPublish = null;
      } else if (this.statusData.status === 'published') {
        if (!this.statusData.startPublish) {
          this.statusData.startPublish = new Date();
        }
      } else if (this.statusData.status === 'scheduled') {
        const startDate = new Date(this.statusData.startPublish);
        if (startDate < date) {
          this.statusData.status = 'published';
        }
      }
      this.onChange(this.statusData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.status-box-container {
  display: flex;
  justify-content: space-between;
  .status-box {
    cursor: pointer;
    color: $gray-500;
    display: flex;
    width: 120px;
    align-items: center;
    padding: $spacer / 2;
    border: 1px solid $gray-300;
    border-radius: 5px;
    transition: all .2s ease-in-out;
    .status-bullet {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      margin-right: $spacer / 2;
      background: $gray-300;
      transition: all .2s ease-in-out;
    }
  }

  .publish-box:hover, .publish-selected {
    border-color: $success;
    color: $success;
    .status-bullet {
      background: $success;
    }
  }

  .schedule-box:hover, .schedule-selected {
    border-color: $yellow;
    color: $yellow;
    .status-bullet {
      background: $yellow;
    }
  }

  .draft-box:hover, .draft-selected {
    border-color: $gray-800;
    color: $gray-800;
    .status-bullet {
      background: $gray-500;
    }
  }
}

.status-section {
  label {
    margin-bottom: $spacer * 0.15;
  }
}

.status-startpublish, .status-endpublish {
  margin-top: $spacer * 1.5;

  label {
    margin-bottom: $spacer * 0.15;
  }
}

.status-endpublish {
  .checkbox-container {
    margin-bottom: $spacer * 0.15;
  }
}

.end-date-section {
  .checkbox-container {
    color: $secondary;
  }
}


</style>
